
export default function(o, credentials, done){

  var data = {
    type: 'login',
    email: credentials.email,
    password: credentials.password,
  }

  $.ajax({
    url: '/auth',
    type: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    contentType: "application/json",
    data: JSON.stringify(data)
  })
  .done(function(result, textStatus, jqXHR) {
    if(result.error){
      done(result)
    } else {
      done(null,result);
    }
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    done({error: 'post failed'});
  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/login/login.js